import script from "./WorstIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./WorstIndicator.vue?vue&type=script&setup=true&lang=js"

import "./WorstIndicator.vue?vue&type=style&index=0&id=788fe409&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788fe409"]])

export default __exports__